<template>
    <div>
        <Header :headerData="headerData"></Header>

        <!-- 页面内容整体下移间距 -->
        <div class="content_spacer"></div>

        <div class="operate_btn">
            <a-select
                v-if="userInfo.tenant_id == 1"
                class="query_field"
                v-model:value="searchForm.tenant_id"
                :placeholder="t('upgradeRules.tenant')"
                :options="tenantOptions"
                style="margin-right:10px;width:200px"
                @change="()=>{ table.configs.pagination.current = 1; fetchTableData(); }"
            ></a-select>
            <a-button type="primary" size="small" style="margin-right:10px;margin-bottom:10px" @click="openModal('add')">
                <component :is="$antIcons['PlusOutlined']" style="margin-right: 5px;margin-top:-3px"></component>
                {{ t('upgradeRules.add') }}
            </a-button>
        </div>

        <Table
            ref="tableRef"
            class="table"
            :table="table"
            @handleChangePagination="handleChangePagination"
            @expandRow="expandRow"
        >
            <template #customCol="{ props }">
                <template v-if="props.column.key === 'status'">
                    {{ mapStatus(props.record.status) }}
                </template>
                <template v-else-if="props.column.key !== 'action'">
                    {{ formatCell(props.record[props.column.dataIndex]) }}
                </template>
            </template>
            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button size="small" type="primary" style="margin-right:10px"
                        :disabled="normalizeFlag(props.record.status) === 1"
                        @click="openModal('edit', props.record)"
                    >
                        {{ t('upgradeRules.edit') }}
                    </a-button>
                    <a-button size="small"
                        :disabled="normalizeFlag(props.record.status) === 1"
                        @click="handleCancelRule(props.record)"
                    >
                        {{ t('base.cancel') }}
                    </a-button>
                </template>
            </template>

            
            <template #childCustomCol="{ props }">
                <template v-if="props.column.key === 'project_no'">
                    {{ props.record.project_no && String(props.record.project_no).trim() !== '' ? props.record.project_no : '-' }}
                </template>
                <template v-else-if="props.column.key !== 'action'">
                    {{ formatCell(props.record[props.column.dataIndex]) }}
                </template>
            </template>
        </Table>

        <a-modal 
            v-model:open="modalVisible"
            :title="modalType === 'add' ? t('upgradeRules.add') : t('upgradeRules.edit')"
            :width="1200"
            centered
            :footer="null"
        >
            <div class="form form-horizontal">
                <div class="form_row">
                    <label class="form_label"><span class="required">*</span>{{ t('upgradeRules.ruleName') }}</label>
                    <a-input v-model:value="formData.rule_name" allowClear :maxlength="25" show-count placeholder="Please Enter" class="form_input" />
                </div>
                <div class="form_row">
                    <label class="form_label"><span class="required">*</span>{{ t('upgradeRules.priority') }}</label>
                    <a-input-number 
                        v-model:value="formData.priority" 
                        :min="0" 
                        :precision="0" 
                        :parser="parseInteger"
                        class="form_input" 
                        style="width: 100%" 
                        @keydown="handleDigitKeydown"
                        @paste="handlePasteDigits($event, 'form', 'priority')"
                    />
                </div>

                <div class="rule_item_header">
                    <a-button type="primary" size="small" @click="addRuleItem">
                        <component :is="$antIcons['PlusCircleOutlined']" style="margin-top:2px;font-size:17px"></component>
                        {{ t('upgradeRules.addRuleItem') }}
                    </a-button>
                </div>

                <div class="rule_items_table">
                    <div class="rule_items_header">
                        <div class="col part_no">{{ t('upgradeRules.partNo') }}</div>
                        <div class="col hardware">{{ t('upgradeRules.ruleHardware') }}</div>
                        <div class="col min">{{ t('upgradeRules.ruleMinValue') }}</div>
                        <div class="col max">{{ t('upgradeRules.ruleMaxValue') }}</div>
                        <div class="col item_priority">{{ t('upgradeRules.ruleItemPriority') }}</div>
                        <div class="col project">{{ t('upgradeRules.projectNo') }}</div>
                        <div class="col operate">{{ t('base.operate') }}</div>
                    </div>
                    <div class="rule_item_row" v-for="(row,idx) in ruleItemList" :key="idx">
                        <div class="col part_no">
                            <a-select v-model:value="row.part_no" :options="partNoOptions" allowClear showSearch @change="(v)=>onSelectPartNo(v, idx)" style="width:100%"></a-select>
                        </div>
                        <div class="col hardware">
                            <a-select v-model:value="row.rule_hardware" :options="row.hardwareOptions || []" allowClear showSearch :disabled="!row.part_no" style="width:100%"></a-select>
                        </div>
                        <div class="col min">
                            <a-input-number 
                                v-model:value="row.rule_min_value" 
                                :min="0"
                                :precision="0" 
                                :parser="parseInteger"
                                style="width:100%" 
                                @keydown="handleDigitKeydown"
                                @paste="handlePasteDigits($event, 'item', 'rule_min_value', idx)"
                            />
                        </div>
                        <div class="col max">
                            <a-input-number 
                                v-model:value="row.rule_max_value" 
                                :min="0"
                                :precision="0" 
                                :parser="parseInteger"
                                style="width:100%" 
                                @keydown="handleDigitKeydown"
                                @paste="handlePasteDigits($event, 'item', 'rule_max_value', idx)"
                            />
                        </div>
                        <div class="col item_priority">
                            <a-input-number 
                                v-model:value="row.rule_item_priority" 
                                :min="0" 
                                :precision="0" 
                                :parser="parseInteger"
                                style="width:100%" 
                                @keydown="handleDigitKeydown"
                                @paste="handlePasteDigits($event, 'item', 'rule_item_priority', idx)"
                            />
                        </div>
                        <div class="col project">
                            <a-input v-model:value="row.project_no" allowClear style="width:100%" />
                        </div>
                        <div class="col operate">
                            <a-button class="rule-delete-btn" type="primary" ghost size="small" @click="removeRuleItem(idx)" :disabled="ruleItemList.length === 1">
                                <component :is="$antIcons['DeleteOutlined']"></component>
                                {{ t('base.delete') }}
                            </a-button>
                        </div>
                    </div>
                </div>

                <div class="form_btns">
                    <a-button style="margin-right: 16px;" @click="modalVisible = false">{{ t('base.cancel') }}</a-button>
                    <a-button type="primary" @click="handleSubmit">{{ t('base.confirm') }}</a-button>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script setup>
    import { ref, reactive, onMounted } from 'vue';
    import Table from '@/components/Table.vue';
    import Header from "@/layouts/component/Header.vue";
    import { getWeek } from '@/hooks/useGetWeek';
    import { useI18n } from 'vue-i18n';
    import { UpgradeRulesApi } from '@/api/UpgradeRulesApi.js';
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js';
    import { message, Modal } from 'ant-design-vue';

    const { t } = useI18n();

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const searchForm = reactive({
        tenant_id: (userInfo.value?.tenant_id == 1) ? null : (userInfo.value?.tenant_id || ''),
    })
    const tenantOptions = ref([])

    defineOptions({ name: 'UpgradeRules' })

    const headerData = ref({
        menu:'menu.upgradeRules',
        menu_desc: 'menu.subUpgradeRules',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })

    const table = ref({
        data: [],
        columns: [
            { title: t('upgradeRules.ruleName'), dataIndex: 'rule_name', key: 'rule_name', width: 180, resizable: true },
            { title: t('upgradeRules.priority'), dataIndex: 'priority', key: 'priority', width: 140, resizable: true },
            { 
                title: t('upgradeRules.status'), 
                dataIndex: 'status', 
                key: 'status', 
                width: 140,
                filterMultiple: false,
                filters: [
                    { text: t('upgradeRules.normal'), value: 'Normal' },
                    { text: t('upgradeRules.canceled'), value: 'Canceled' },
                ],
                onFilter: (value, record) => {
                    const n = normalizeFlag(record.status)
                    if(value === 'Normal') return n === 0
                    if(value === 'Canceled') return n === 1
                    return true
                }
            },
            { title: t('upgradeRules.createTime'), dataIndex: 'create_time', key: 'create_time', width: 160 },
            { title: t('upgradeRules.cancelTime'), dataIndex: 'cancel_time', key: 'cancel_time', width: 160 },
            { title: t('account.tenant'), dataIndex: 'tenant_name', key: 'tenant_name', width: 140, resizable: true },
            { title: t('base.operate'), key: 'action', width: 120, fixed: 'right' },
        ],
        configs: {
            table: {
                rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1260,
                y: 520,
            },
            rowSelection: false,
            loading: false,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                position: ['bottomLeft'],
                showSizeChanger: true,
                pageSizeOptions: ['10','20','50'],
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
        children:[{
            title:'',
            innerData:[],
            innerColumns:[
                { title: t('upgradeRules.partNo'), dataIndex: 'part_no', key: 'part_no', width: 120 },
                { title: t('upgradeRules.ruleHardware'), dataIndex: 'rule_hardware', key: 'rule_hardware', width: 120 },
                { title: t('upgradeRules.ruleMinValue'), dataIndex: 'rule_min_value', key: 'rule_min_value', width: 120 },
                { title: t('upgradeRules.ruleMaxValue'), dataIndex: 'rule_max_value', key: 'rule_max_value', width: 120 },
                { title: t('upgradeRules.ruleItemPriority'), dataIndex: 'rule_item_priority', key: 'rule_item_priority', width: 130 },
                { title: t('upgradeRules.projectNo'), dataIndex: 'project_no', key: 'project_no', width: 160 },
            ],
            innerConfigs: {
                table:{
                    rowClassName:(record, index)=>{ return 'subTableBg'}
                },
                rowSelection: false,
                loading: false,
                pagination: false,
                operateBtn: {
                    showSearch: false,
                    showAdd: false,
                }
            },
        }]
    })

    const normalizeFlag = (val) => {
      if (val === 0 || val === '0' || val === 'YES' || val === 'Yes' || val === 'yes' || val === true || val === 'Normal') return 0;
      if (val === 1 || val === '1' || val === 'NO' || val === 'No' || val === 'no' || val === false || val === 'Canceled' || val === 'Cancel') return 1;
      return val;
    };
    const mapStatus = (val) => {
      const n = normalizeFlag(val);
      if (n === 0) return t('upgradeRules.normal');
      if (n === 1) return t('upgradeRules.canceled');
      return val ?? '';
    };

    // 统一空值显示为 '-'
    const formatCell = (val)=>{
        if(val === undefined || val === null) return '-'
        const s = String(val)
        if(s.trim() === '') return '-'
        return s
    }

    const modalVisible = ref(false);
    const modalType = ref('add');
    const formData = reactive({
        id: undefined,
        rule_name: '',
        priority: undefined,
    });

    const ruleItemList = ref([]);
    const partNoOptions = ref([]);

    const fetchTableData = async ()=>{
        table.value.configs.loading = true;
        const page_num = table.value.configs.pagination.current;
        const page_size = table.value.configs.pagination.pageSize;
        const res = await UpgradeRulesApi.getInstance().getRuleList({ sys_org: (userInfo.value?.tenant_id == 1 ? searchForm.tenant_id : userInfo.value?.tenant_id) }, page_num, page_size);
        if(res.code === 0){
            const data = res.data
            const optionsMap = (tenantOptions.value || []).reduce((acc, cur)=>{ if(cur.value !== null && cur.value !== undefined){ acc[cur.value] = cur.label }; return acc }, {})
            const fallbackTenantMap = { 0: 'hepha', 1: 'gobao', 6: 'corest' }
            table.value.data = (data.records || []).map((item, idx)=>({
                id: item.id,
                rule_name: item.rule_name,
                priority: item.priority,
                status: item.status,
                create_time: item.create_time,
                cancel_time: item.cancel_time,
                tenant_name: optionsMap[item.sys_org] || fallbackTenantMap[item.sys_org] || '-',
                index: idx,
            }))
            table.value.configs.pagination.total = data.total || 0
            // 刷新父表后清空子表缓存，避免显示历史数据
            if(table.value.children && table.value.children[0]){
                table.value.children[0].innerData = []
            }
            // 确保展开行收起
            if(tableRef.value){
                try{ tableRef.value.expandedRowKeys = [] }catch(e){}
            }
        }else{
            message.error(res.msg || 'Error');
            throw new Error(res.msg || 'Error');
        }
        table.value.configs.loading = false;
    }

    const tableRef = ref(null)
    const expandRow = async (expanded, record)=>{
        if(!expanded){
            // 折叠时清空子表数据，避免下次展开残留
            if(table.value.children && table.value.children[0]){
                table.value.children[0].innerData = []
            }
            return;
        }
        // 按规则ID精确查询该规则的条目
        const param = { rules: record.id };
        const res = await UpgradeRulesApi.getInstance().getRuleItemList(param);
        if(res.code === 0){
            const data = res.data
            const raw = (data.records || data || [])
            const filtered = filterItemsByRuleId(raw, record.id)
            table.value.children[0].innerData = filtered.map(it=>({
                part_no: it.part_no,
                rule_hardware: String(it.hardware_version ?? it.rule_hardware ?? ''),
                rule_min_value: (it.rule_min_val ?? it.value_min ?? it.rule_min_value),
                rule_max_value: (it.rule_max_val ?? it.value_max ?? it.rule_max_value),
                rule_item_priority: (it.priority ?? it.rule_item_priority),
                project_no: it.project_no,
            }))
        }else{
            table.value.children[0].innerData = [];
            throw new Error(res.msg || 'Error');
        }
    }

    const handleChangePagination = async (pagination) => {
        if(pagination){
            table.value.configs.pagination.current = pagination.current || 1
            table.value.configs.pagination.pageSize = pagination.pageSize || table.value.configs.pagination.pageSize
        }
        // 切换分页或每页条数时，收起所有已展开的子表格
        try{
            if(tableRef.value && tableRef.value.expandedRowKeys){
                // 兼容两种赋值方式
                try{ tableRef.value.expandedRowKeys.value = [] }catch(e){}
                try{ tableRef.value.expandedRowKeys = [] }catch(e){}
            }
        }catch(e){}
        if(table.value.children && table.value.children[0]){
            table.value.children[0].innerData = []
        }
        await fetchTableData();
    }

    const loadPartNoOptions = async ()=>{
        const res = await UpgradeRulesApi.getInstance().getPartsList();
        if(res.code === 0){
            const data = res.data
            partNoOptions.value = (data.records || data || []).map(i=>{
                const val = (i && typeof i === 'object')? i.part_no : i
                return { label: val, value: val }
            })
        }else{
            throw new Error(res.msg || 'Error');
        }
    }

    const onSelectPartNo = async (val, idx, preserveHardware = false)=>{
        const row = ruleItemList.value[idx]
        const previousHardware = row.rule_hardware
        if(!preserveHardware){
            row.rule_hardware = undefined
        }
        if(val === undefined || val === null || val === ''){
            row.hardwareOptions = []
            return;
        }
        const res = await UpgradeRulesApi.getInstance().getHardwareList({ part_no: val });
        if(res.code === 0){
            const data = res.data
            const list = (data.records || data || [])
            // 仅使用接口返回的 hardware_version，且去重
            const values = list.map(h=>{
                if(h && typeof h === 'object' && h.hardware_version !== undefined && h.hardware_version !== null){
                    return String(h.hardware_version)
                }
                return String(h ?? '')
            }).filter(v=>v !== '')
            const uniq = Array.from(new Set(values))
            if(preserveHardware){
                const existsInNew = previousHardware && uniq.includes(previousHardware)
                if(!existsInNew){
                    row.rule_hardware = undefined
                }
            }
            row.hardwareOptions = uniq.map(v=>({ label: v, value: v }))
        }else{
            row.hardwareOptions = []
            throw new Error(res.msg || 'Error');
        }
    }

    const openModal = async (type, record)=>{
        modalType.value = type;
        if(type === 'add'){
            formData.id = undefined
            formData.rule_name = ''
            formData.priority = undefined
            ruleItemList.value = [createEmptyItem()]
        }else{
            formData.id = record.id
            formData.rule_name = record.rule_name
            formData.priority = record.priority
            const res = await UpgradeRulesApi.getInstance().getRuleItemList({ rules: record.id })
            if(res.code === 0){
                const data = res.data
                const raw = (data.records || data || [])
                const filtered = filterItemsByRuleId(raw, record.id)
                ruleItemList.value = filtered.map(it=>({
                    part_no: it.part_no,
                    rule_hardware: String(it.hardware_version ?? it.rule_hardware ?? ''),
                    rule_min_value: (it.rule_min_val ?? it.value_min ?? it.rule_min_value),
                    rule_max_value: (it.rule_max_val ?? it.value_max ?? it.rule_max_value),
                    rule_item_priority: (it.priority ?? it.rule_item_priority),
                    project_no: it.project_no,
                    hardwareOptions: []
                }))
                for(let i=0;i<ruleItemList.value.length;i++){
                    if(ruleItemList.value[i].part_no){
                        await onSelectPartNo(ruleItemList.value[i].part_no, i, true)
                    }
                }
            }else{
                ruleItemList.value = [createEmptyItem()]
                throw new Error(res.msg || 'Error');
            }
        }
        modalVisible.value = true
    }

    const createEmptyItem = ()=>({
        part_no: undefined,
        rule_hardware: undefined,
        rule_min_value: undefined,
        rule_max_value: undefined,
        rule_item_priority: undefined,
        project_no: '',
        hardwareOptions: []
    })

    const addRuleItem = ()=>{
        ruleItemList.value.push(createEmptyItem())
    }
    const removeRuleItem = (idx)=>{
        Modal.confirm({
            title: t('base.tip'),
            content: t('base.deleteConfirm'),
            okText: t('base.confirm'),
            cancelText: t('base.cancel'),
            onOk: ()=>{
                ruleItemList.value.splice(idx,1)
                if(ruleItemList.value.length === 0){
                    ruleItemList.value.push(createEmptyItem())
                }
            }
        })
    }

    const handleSubmit = async ()=>{
        if(!formData.rule_name || formData.rule_name.trim() === ''){
            return message.warning(t('upgradeRules.inputRuleName'))
        }
        if(formData.priority === undefined || formData.priority === null || formData.priority === '' || Number(formData.priority) < 0){
            return message.warning(t('upgradeRules.inputPriority'))
        }
        // 校验每个条目的必填字段
        for(let i=0;i<ruleItemList.value.length;i++){
            const it = ruleItemList.value[i]
            if(it.part_no === undefined || it.part_no === null || String(it.part_no).trim() === ''){
                return message.warning(t('upgradeRules.inputPartNo'))
            }
            if(it.rule_hardware === undefined || it.rule_hardware === null || String(it.rule_hardware).trim() === ''){
                return message.warning(t('upgradeRules.inputRuleHardware'))
            }
            if(it.rule_min_value === undefined || it.rule_min_value === null || String(it.rule_min_value) === ''){
                return message.warning(t('upgradeRules.inputRuleMinValue'))
            }
            if(it.rule_max_value === undefined || it.rule_max_value === null || String(it.rule_max_value) === ''){
                return message.warning(t('upgradeRules.inputRuleMaxValue'))
            }
            if(it.rule_item_priority === undefined || it.rule_item_priority === null || String(it.rule_item_priority) === ''){
                return message.warning(t('upgradeRules.inputRuleItemPriority'))
            }
            if(it.project_no === undefined || it.project_no === null || String(it.project_no).trim() === ''){
                return message.warning(t('upgradeRules.inputProjectNo'))
            }
            const minVal = Number(it.rule_min_value)
            const maxVal = Number(it.rule_max_value)
            if(!Number.isFinite(minVal) || !Number.isFinite(maxVal)){
                return message.warning(t('base.error'))
            }
            if(minVal > maxVal){
                return message.warning(t('upgradeRules.minGreaterThanMax'))
            }
        }
        

        const items = ruleItemList.value.map(it=>({
            part_no: it.part_no,
            rule_hardware: String(it.rule_hardware),
            rule_min_val: Number(it.rule_min_value),
            rule_max_val: Number(it.rule_max_value),
            priority: Number(it.rule_item_priority ?? 0),
            project_no: (it.project_no && String(it.project_no).trim() !== '' ? String(it.project_no).trim() : null),
        }))
        const rules = {
            rule_name: formData.rule_name.trim(),
            priority: Number(formData.priority)
        }
        if(formData.id){ rules.id = formData.id }
        const param = {
            rules,
            items
        }
        let res
        if(modalType.value === 'add'){
            res = await UpgradeRulesApi.getInstance().addRule(param)
        }else{
            res = await UpgradeRulesApi.getInstance().editRule(param)
        }
        if(res.code === 0){
            message.success(t('base.success'))
            modalVisible.value = false
            if(modalType.value === 'add'){
                table.value.configs.pagination.current = 1
                await fetchTableData()
            }else{
                const current = table.value.configs.pagination.current
                await fetchTableData()
                table.value.configs.pagination.current = current
                await expandRow(true, { id: formData.id })
            }
        }else{
            message.error(res.msg || 'Error')
            throw new Error(res.msg || 'Error')
        }
    }

    const handleCancelRule = (record)=>{
        Modal.confirm({
            title: t('upgradeRules.cancelTitle'),
            content: t('upgradeRules.confirmCancel'),
            okText: t('base.confirm'),
            cancelText: t('base.cancel'),
            onOk: async ()=>{
                const res = await UpgradeRulesApi.getInstance().cancelRule(record.id)
                if(res.code === 0){
                    message.success(t('base.success'))
                    fetchTableData()
                }else{
                    message.error(res.msg || 'Error')
                    throw new Error(res.msg || 'Error')
                }
            }
        })
    }

    

    // 仅允许数字键 + 方向键 + 删除/回退
    const handleDigitKeydown = (e)=>{
        const allowed = ['Backspace','Delete','ArrowLeft','ArrowRight','Tab']
        if(allowed.includes(e.key)) return
        if(/^[0-9]$/.test(e.key)) return
        e.preventDefault()
    }

    const parseInteger = (val)=>{
        if(typeof val === 'number') return Math.floor(val)
        return String(val || '').replace(/[^\d]/g,'')
    }

    // 粘贴时只允许数字
    const handlePasteDigits = (evt, scope, field, idx)=>{
        const text = (evt.clipboardData || window.clipboardData).getData('text')
        if(/^[0-9]+$/.test(text)) return
        evt.preventDefault()
        const digits = text.replace(/[^\d]/g,'')
        if(scope === 'form'){
            if(field === 'priority') formData.priority = digits ? Number(digits) : undefined
        }else if(scope === 'item'){
            if(typeof idx === 'number'){
                if(field === 'rule_min_value') ruleItemList.value[idx].rule_min_value = digits ? Number(digits) : undefined
                if(field === 'rule_max_value') ruleItemList.value[idx].rule_max_value = digits ? Number(digits) : undefined
                if(field === 'rule_item_priority') ruleItemList.value[idx].rule_item_priority = digits ? Number(digits) : undefined
            }
        }
    }

    // 根据父规则ID过滤子项
    const filterItemsByRuleId = (items, ruleId)=>{
        const list = Array.isArray(items)? items : []
        const idStr = String(ruleId)
        const hasIdField = list.some(it=>('rule_id' in it) || ('rules' in it) || ('ruleId' in it) || ('upgradeRuleId' in it))
        if(!hasIdField){
            // 后端未返回规则ID，直接使用原始数据
            return list
        }
        const filtered = list.filter(it=>{
            const candidates = [it.rule_id, it.rules, it.ruleId, it.upgradeRuleId]
            return candidates.some(v=>v !== undefined && v !== null && String(v) === idStr)
        })
        // 若存在ID字段但没有匹配项，返回空数组
        return filtered
    }

    const getTenantList = async()=>{
        let param = {
            limit_size: 100,
        }
        let res = await AdvancedFunApi.getInstance().getAllTenant2(param)
        if(res?.code === 0){
            tenantOptions.value = (res.data || []).map(item=>({ label: item.tenant_name, value: item.tenant_id }))
            if(userInfo.value?.tenant_id == 1){
                tenantOptions.value.unshift({ label: t('access.allTenant'), value: null })
            }
        } else {
            message.error(res.msg || t('base.getDataFail'));
        }
    }

    onMounted(async ()=>{
        await getTenantList()
        await fetchTableData()
        await loadPartNoOptions()
    })
</script>

<style lang="scss" scoped>
.operate_btn{
    margin-top: -10px;
    margin-bottom: 20px;
}

/* 统一表格行距（参考 Access/Account 页面） */
::v-deep .ant-table-wrapper .ant-table-thead>tr>th,
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td,
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

.form{
    .form_row{
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .form_label{
            width: 140px;
            text-align: right;
            padding-right: 12px;
        }
        .form_input{
            flex: 1;
        }
        .required{ color: red; margin-right: 4px; }
    }

    .rule_item_header{
        margin: 10px 0;
    }

    .rule_items_table{
        border: 1px solid #eee;
        border-radius: 4px;
        .rule_items_header{
            display: grid;
            grid-template-columns: 150px 150px 120px 120px 150px 1fr 130px;
            background: #e7edfb;
            padding: 8px;
            column-gap: 0;
            font-weight: 600;
            .col{ text-align: center; }
        }
        .rule_item_row{
            display: grid;
            grid-template-columns: 150px 150px 120px 120px 150px 1fr 130px;
            column-gap: 0;
            row-gap: 0;
            padding: 10px 8px;
            border-top: 1px solid #f0f0f0;
            align-items: center;
        }
        .col{ padding: 0 8px; }
        .col.operate{ display: flex; justify-content: center; }
    }

    .form_btns{
        text-align: right;
        margin-top: 16px;
    }
}

:deep(.page_header .week) {
    margin-top: -48px !important;
}

:deep(.page_header .admin_email) {
    margin-top: -37.5px !important;
    margin-right: 70px !important;
}

.content_spacer{
    height: 60px;
}
</style>